import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false
// t9
import 'element-ui/lib/theme-chalk/index.css'
import '../common/css/common_repair.css'
import TDesign from 'tdesign-vue'
// 引入组件库全局样式资源
import 'tdesign-vue/es/style/index.css'
import Bus from '../common/js/bus'
Vue.prototype.Bus = Bus
Vue.use(TDesign)
Vue.use(ElementUI)
// 过滤器
import dayjs from 'dayjs'
Vue.prototype.$dayjs = dayjs
import * as globalFilter from './filters/filters'
for (var key in globalFilter) {
  Vue.filter(key, globalFilter[key])
}
import 'animate.css/animate.compat.css'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
Vue.use(VideoPlayer)
// import SlideVerify from 'vue-monoplasty-slide-verify'
// Vue.use(SlideVerify)

import { o2vr } from '../common/js/o2'
Vue.prototype.O2vr = new o2vr()
document.o2vr = Vue.prototype.O2vr
document.o2 = Vue.prototype.O2vr

import { o2vrClient } from '../common/js/wdfClient'
import { o2Function } from '../common/js/o2Function'
import { chat } from '../common/js/chatLatestwdf'

//音视频通话
Vue.prototype.$client = new o2vrClient()
Vue.prototype.$o2Function = new o2Function()
Vue.prototype.$chat = new chat()
document.chat = new chat()

import VueI18n from 'vue-i18n'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import ElementUI from 'element-ui'
import { playerMgr } from '../common/js/playerMgr.js'

document.o2.project_id = 3
document.o2.playerMgr = new playerMgr()

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'zh',
  messages: {
    zh: { info: require('./assets/lang/zh.js'), ...zhLocale },
    en: { info: require('./assets/lang/en.js'), ...enLocale }
  }
})

new Vue({
  router,
  // store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
